import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-general',
  templateUrl: './error-general.component.html',
  styleUrls: ['./error-general.component.css']
})
export class ErrorGeneralComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {
  }

  goToHome(){
    this.router.navigateByUrl('/consulta')
  }
}
